export enum FilterType {
  MultiSelect = "MultiSelect",
  Toggle = "Toggle",
  // DateRange = "DateRange",
  // MonthRange = "MonthRange",
  // Slider = "Slider",
  // Custom = "Custom", // For any custom filter logic
}
